import React from 'react'
import PropTypes from "prop-types"
import Input from "./Input";

const Currency = props => {
  return (
      <Input
        className={props.className}
        id={props.id}
        value={props.value}
        type="number"
        name={props.id}
        label={props.label}
        isInvalid={props.isInvalid}
        invalidMessage={props.invalidMessage}
        onChange={props.onChange}
        onBlur={props.onBlur}
        formField={props.formField}
        icon="fz-euro solid"
        numberFormat={{
          negative: false,
          decimalPlaces: 2,
        }}
        formatDecimalNumber={true}
        disabled={props.disabled}
      />
  )

}

Currency.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.string,
  label: PropTypes.string,
  isInvalid: PropTypes.bool,
  invalidMessage: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  formField: PropTypes.object,
  disabled: PropTypes.bool
};


export default Currency
